declare const window: {
  rudderanalytics: any;
} & Window;

export const applyLinkClicked = (clickedElement) => {
  if (
    typeof window !== 'undefined' &&
    window.rudderanalytics !== undefined &&
    getQueryId() !== undefined &&
    getObjectIds().length > 0 &&
    getPositions().length > 0
  ) {
    window.rudderanalytics.setAnonymousId(getUserToken());
    window.rudderanalytics.track('Search Result Apply Clicked', {
      eventType: 'click',
      index: 'programs',
      timestamp: Date.now(),
      objectIds: getClickedObjectAttribute(clickedElement, 'data-insights-object-id'),
      positions: getClickedObjectAttribute(clickedElement, 'data-insights-position'),
      queryId: getQueryId(),
      objectData: getObjectData(clickedElement),
    });
  }
  return true;
};

export const hitsViewed = () => {
  if (
    typeof window !== 'undefined' &&
    window.rudderanalytics !== undefined &&
    getQueryId() !== undefined &&
    getObjectIds().length > 0 &&
    getPositions().length > 0
  ) {
    window.rudderanalytics.setAnonymousId(getUserToken());

    if (!getSessionQueries() || getSessionQueries().indexOf(getQueryId()) === -1) {
      window.rudderanalytics.track('Search Results Viewed', {
        eventType: 'view',
        index: 'programs',
        timestamp: Date.now(),
        objectIds: getObjectIds(),
        positions: getPositions(),
        queryId: getQueryId(),
      });

      if (getSessionQueries()) {
        sessionStorage.setItem(`searchQueryIds`, `${getSessionQueries()},${getQueryId()}`);
      } else {
        sessionStorage.setItem(`searchQueryIds`, getQueryId());
      }
    }
  }
  return true;
};

const getSessionQueries = () => {
  if (typeof window !== `undefined` && window.sessionStorage) {
    const sessionStorageSearchQueryIds = sessionStorage.getItem(`searchQueryIds`);
    return sessionStorageSearchQueryIds;
  }
  return undefined;
};

const getUserToken = () => {
  if (typeof window !== `undefined` && window.localStorage) {
    let searchUserToken = `anonymous-user-empty`;

    const localStorageSearchUserToken = localStorage.getItem(`searchUserToken`);
    if (localStorageSearchUserToken === null) {
      searchUserToken = `anonymous-user-${Math.random().toString(20).substr(2, 6)}`;
      localStorage.setItem(`searchUserToken`, searchUserToken);
    } else {
      searchUserToken = localStorageSearchUserToken;
    }

    return searchUserToken;
  }

  return `anonymous-user-no-local-storage`;
};

const findClosestPreviousSibling = (target, selector) => {
  while (!target.matches(selector) && !target.matches('body')) {
    target = target.previousElementSibling;
  }
  return target.matches(selector) ? target : undefined;
};

const findClosest = (target, selector) => {
  while (!target.matches(selector) && !target.matches('body')) {
    target = target.parentElement;
  }
  return target.matches(selector) ? target : undefined;
};

const getObjectData = (clickedElement) => {
  return [
    {
      mainProgramName: getClickedSubElementAttribute(
        clickedElement,
        `data-heap-payload-mainprogram`,
      ),
      pathwayProgramName: getClickedSubElementAttribute(
        clickedElement,
        `data-heap-payload-pathwayprogram`,
      ),
      brandName: getClickedSubElementAttribute(clickedElement, `data-heap-payload-brand`),
      searchTerm: getSearchTerm(),
    },
  ];
};

const getClickedSubElementAttribute = (clickedElement, attributeName) => {
  const element = findClosestPreviousSibling(clickedElement, '[' + attributeName + ']');
  return element.getAttribute(attributeName);
};

const getClickedObjectAttribute = (clickedElement, attributeName) => {
  const elements = [findClosest(clickedElement, '[' + attributeName + ']')];
  const attributes = elements.map(function (element) {
    return element.getAttribute(attributeName);
  });

  return attributes;
};

const getSearchTerm = () => {
  const attributeName = 'input#typeahead-search-input';
  const element = document.querySelector(attributeName);
  return element.getAttribute('value');
};

const getPositions = () => {
  const attributeName = `data-insights-position`;
  return getMultipleAttributes(attributeName);
};

const getObjectIds = () => {
  const attributeName = `data-insights-object-id`;
  return getMultipleAttributes(attributeName);
};

const getQueryId = () => {
  const attributeName = `data-insights-query-id`;
  return getSingleAttributeValue(attributeName);
};

const getSingleAttributeValue = (attributeName) => {
  const attributes = getMultipleAttributes(attributeName);
  return attributes[0];
};

const getMultipleAttributes = (attributeName) => {
  const elements = Array.from(document.querySelectorAll(`[${attributeName}]`));
  const attributes = elements.map((element) => element.getAttribute(attributeName));
  return attributes;
};
